<form [formGroup]="form">
  <table>
    <tbody class="inner">
      <tr>
        <!--<td>&nbsp;</td>-->
        <td>&nbsp;</td>
        <td>
          @if (!newRow) {
            <span>{{list[rowIndex].ErrorCode}}</span>
          }
          @if (newRow) {
            <input type="number"
              formControlName="ErrorCode"
              placeholder="enter the error code..."
              title="enter the error code..."
              class="form-control"
              (change)="onInputChange($event)"
              />
          }

        </td>

        <td>
          @if (!newRow) {
            <span>{{list[rowIndex].Description_ref}}<br /></span>
          }
        </td>

        <td>
          @if (!newRow) {
            <span>{{errorcode.Description}}<br /></span>
          }
          <textarea id="description"
            formControlName="Description" required
            placeholder="enter the description..."
            class="form-control"
            [ngClass]="classname[DESCRIPTION]"
            (change)="onInputChange($event)">
          </textarea>
          @if (!newRow) {
            <button type="button" [disabled]="isundodisabled[DESCRIPTION] == true" (click)="onUndo()" class="btn btn-default" title="Undo changes">
              <span class='glyphicon glyphicon-arrow-left'></span>
            </button>
          }
        </td>

        <td>
          <button type="button"
            class="btn btn-warning"
            (click)="onRowCancel()">
            Cancel
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</form>
